export const ENV = 'prod';
export const GENERIC_URL = {
  local: {
    api: 'http://localhost:6699/',
    core: 'https://sit.ambslot-api.com/',
    apiHub: 'https://api-staging.ambprovider-hub.com/',
    centralApi: 'https://central-sit-api.ambplay.com/',
    socket: 'https://skt-staging.ambslot-api.com/',
    bonus: 'https://angpow-dev.pgslot.cc/',
    result: 'https://report-staging.ambslot.com/',
    user: 'https://staging.ambslot-api.com/report/user-online',
    dolly: 'https://sit.ambslot-api.com/angpow/legendofdolly/report',
  },
  dev: {
    api: 'https://web-api-sit.ambslot-api.com/',
    core: 'https://sit.ambslot-api.com/',
    apiHub: 'https://api-staging.ambprovider-hub.com/',
    centralApi: 'https://central-sit-api.ambplay.com/',
    socket: 'https://skt-sit.ambslot-api.com/',
    bonus: 'https://angpow-dev.pgslot.cc/',
    result: 'https://report-staging.ambslot.com/',
    user: 'https://sit.ambslot-api.com/report/user-online',
    dolly: 'https://sit.ambslot-api.com/angpow/legendofdolly/report',

  },
  uat: {
    api: 'https://web-api-uat.ambslot-api.com/',
    core: 'https://uat.ambslot-api.com/',
    apiHub: 'https://api-staging.ambprovider-hub.com/',
    centralApi: 'https://central-uat-api.ambplay.com/',
    socket: 'https://skt-uat.ambslot-api.com/',
    bonus: 'https://angpow-dev.pgslot.cc/',
    result: 'https://report-staging.ambslot.com/',
    user: 'https://staging.ambslot-api.com/report/user-online',
    dolly: 'https://uat.ambslot-api.com/angpow/legendofdolly/report',
  },
  prod: {
    api: 'https://web-api-prod.ambslot-api.com/',
    core: 'https://prod.ambslot-api.com/',
    apiHub: 'https://api-prod.ambprovider-hub.com/',
    centralApi: 'https://central-uat-prod.ambplay.com/',
    socket: 'wss://skt-prod.ambslot-api.com/',
    bonus: 'https://rp99qvzxw0.execute-api.ap-southeast-1.amazonaws.com/angpow-prod/',
    result: 'https://report.ambslot.com/',
    user: 'https://prod.ambslot-api.com/report/user-online',
    dolly: 'https://prod.ambslot-api.com/angpow/legendofdolly/report',
  },
};

export const BASE_URL = GENERIC_URL[ENV].api;
export const CORE_URL = GENERIC_URL[ENV].core;
export const API_HUB_URL = GENERIC_URL[ENV].apiHub;
export const API_CENTRAL_URL = GENERIC_URL[ENV].centralApi;
export const SOCKET_URL = GENERIC_URL[ENV].socket;
export const BONUS_URL = GENERIC_URL[ENV].bonus;
export const RESULT_URL = GENERIC_URL[ENV].result;
export const USER_URL = GENERIC_URL[ENV].user;
export const DOLLY_URL = GENERIC_URL[ENV].dolly;
export const M_GET = 'GET';
export const M_POST = 'POST';
export const M_PUT = 'PUT';
export const M_DELETE = 'DELETE';
export const M_PATCH = 'PATCH';

export const LOGIN = 'auth/login/agent';
export const REFRESH_TOKEN = 'auth/refresh';
export const USERS = 'user/list';
export const GET_USERS_DOWNLINE = 'user/search';
export const USERS_HISTORY = 'user/history';
export const USERS_BALANCE = 'user/balance';
export const USERS_SUBAGENT = 'user/subagent/list';
export const USERS_ACTIVATE = 'user/activate';
export const GET_PROFILE = 'user/profile/get/';
export const UPDATE_PROFILE = 'user/profile/update/';
export const RESET_PASSWORD = 'user/password/reset';
export const UPDATE_COMMISSION = 'user/commission';
export const USERS_GENERATE = 'user/generate';
export const USERS_CREATE = 'user/register';
export const GET_PTSUBAGENT = 'user/ptsubagent';
export const CHECK_PREFIX = 'prefix';
export const GET_GAMES = 'game/list';
export const EDIT_DEMO_URL = 'game/edit/demo';
export const GET_GETGAMES = 'report/winlose/getGames';
export const TRANSACTION_REPORT = 'report/result';
export const GET_TRANSACTIONS = 'version';
export const EDIT_TRANSACTION = 'version/update';
export const EDIT_VERSION_MASCOT = 'version/mascot/update';
//
export const GAME_MAINTENANCE = 'game/maintenance';
export const MAINTENANCE_ALL_SOCKET = 'game/set/maintenance/allprovider';
export const MAINTENANCE_GAMES_SOCKET = 'game/set/maintenance';
export const GAME_VERSION = 'game/version';
export const WINLOSE_REPORT = 'report/winlose/simple';
export const WINLOSE_REPORT_NEW = 'report/winlose/simple/new/v2';
export const WINLOSE_REPORT_NIGHTLY = 'report/winlose/simple/new/v3';
export const WINLOSE_REPORT_LOGS = 'report/winlose/simple/logs';
export const WINLOSE_REPORT_NEW_LOGS = 'report/winlose/simple/log-v2';
export const GAME_REPORT = 'report/game/v2';
export const GAME_REPORT_NIGHTLY = 'report/game/v3';
export const GAME_REPORT_REDIS = 'report/game/report';
export const GAME_REPORT_ELASTIC = 'report/game/elastic';
export const WINLOSE_RESULT = 'result';
export const PROVIDER_REPORT = 'report/winlose/provider';
export const PROVIDER_TYPE_REPORT = 'report/winlose/provider/type';
export const WINLOSE_REPORT_MECHANIC = 'report/mechanic/winlose';
export const WINLOSE_RANGE_DATE_REPORT_LOGS_MECHANIC = 'report/mechanic/daylogs';
export const WINLOSE_LOG_ELASTIC_MECHANIC = 'report/mechanic/elastic-log';
export const UPDATE_PERMISSION = 'user-permission/update';
export const PLAYER_ONLINE = 'player/online';
export const PLAYER_ONLINE_LIST = 'player/online/list';
export const GET_TRANSFER_KEY = 'partner/transfer/fetch';
export const UPDATE_TRANSFER_KEY = 'partner/transfer/edit';
export const GET_SEAMLESS_KEY = 'partner/seamless/fetch';
export const UPDATE_SEAMLESS_KEY = 'partner/seamless/edit';
export const INVOICE_REPORT = 'report/winlose/invoice';
export const FECTH_AGENT = 'report/winlose/fetchAgent';
export const GENERATE_EXCEL_INVOICE = 'report/winlose/invoice/excel';
export const WINLOSE_ROUND_LOG = 'history/round-history';
export const WINLOSE_ROUND_AMBSUPERGAME = 'report/round-history';
export const WINLOSE_RANGE_DATE_REPORT_LOGS = 'report/winlose/dayLogs';
export const WINLOSE_LOG_ELASTIC = 'report/winlose/elastic-log';
export const WINLOSE_DOWNLOAD_REPORT_CSV = 'report/financial/csv';
export const FETCH_ROUND_ID = 'report/search/transaction';

export const TRANSFER = 'wallet/credit/refill';
export const WITHDRAW = 'wallet/credit/deduct';
export const GET_STATEMENT = 'wallet/statement';
export const GET_STATEMENT_DETAIL = 'wallet/statement/detail';
export const CREATE_2FA = 'preauth/twofactor/setup';
export const VERIFY_2FA = 'preauth/twofactor/verify';

// invite friend
export const INVITE_FRIEND_FETCH = 'invite/friend/fetch';
export const INVITE_FRIEND_EDIT = 'invite/friend/edit';

// Bonus
export const BONUS_GET_SUB_USERS = 'key/fetch';
export const BONUS_GET_MAIN_USER = 'key/fetch/product';
export const BONUS_GET_LISTS_SYSTEM = 'agent/generalConfig/fetch';
export const BONUS_SELECT_SYSTEM = 'agent/generalConfig/select';
export const BONUS_UPDATE_CONFIGS = 'agent/generalConfig/update';
export const BONUS_SELECT_ACTIVATE_SYSTEM = 'agent/generalConfig/activeFeature';
export const BONUS_ACTIVATE_ALL_SYSTEM_BY_AGENT = 'agent/generalConfig/active';
export const BONUS_ACTIVATE_GLOBALE_SYSTEM = 'agent/generalConfig/activeGlobal';
export const BONUS_ACTIVATE_MAINTENANCE = 'agent/generalConfig/maintenance';
export const BONUS_ACTIVATE_MAINTENANCE_AGENT = 'agent/generalConfig/maintenanceAgent';
export const BONUS_GET_HISTORY_CONFIG = 'agent/generalConfig/history/fetch';
export const BONUS_DELETE_HISTORY_CONFIG = 'agent/generalConfig/history/delete';
export const BONUS_GET_LOG = 'agent/report/angpow';
export const BONUS_GET_LOG_DETAIL = 'agent/report/angpowTransaction';

// Suggestion
export const SUGGESTION_GET_TOPIC = 'suggestion/fetch';
export const SUGGESTION_CREATE_TOPIC = 'suggestion/create';
export const SUGGESTION_EDIT_TOPIC = 'suggestion/edit';
export const SUGGESTION_DELETE_TOPIC = 'suggestion/delete';
export const SUGGESTION_GET_REPORT = 'suggestion/report';
export const SUGGESTION_SUBMIT = 'suggestion/submit';
export const SUGGESTION_SHEET = 'suggestion/sheet';

// Dashboard
export const DASHBOARD = 'dashboard/v2';
export const DASHBOARD_MEMBER = 'dashboard/member';

// Announcement
export const ANNOUNCEMENT_CREATE = 'announcement/create';
export const ANNOUNCEMENT_UPDATE = 'announcement/update';
export const ANNOUNCEMENT_LIST = 'announcement/list';
export const ANNOUNCEMENT_DELETE = 'announcement/delete';

// AgentBanner
export const AGENT_BANNER_CREATE = 'agentbanner/create';
export const AGENT_BANNER_UPDATE = 'agentbanner/update';
export const AGENT_BANNER_LIST = 'agentbanner/list';
export const AGENT_BANNER_DELETE = 'agentbanner/delete';

// BankAccount
export const BANKACCOUNT_LIST = 'bankaccount/list';
export const BANKACCOUNT_CREATE = 'bankaccount/create';
export const BANKACCOUNT_UPDATE = 'bankaccount/update';
export const BANKACCOUNT_DELETE = 'bankaccount/delete';
export const BANK_NAME_LIST = 'bankaccount/bank/list';

// Social
export const SOCIAL_FETCH = 'social/fetch';
export const SOCIAL_EDIT = 'social/edit';

// Promotion
export const PROMOTION_LIST = 'promotion/list';
export const PROMOTION_CREATE = 'promotion/create';
export const PROMOTION_UPDATE = 'promotion/update';
export const PROMOTION_DELETE = 'promotion/delete';

// subpass
export const FIND_SUBPASS = 'auth/sub-password/find';
export const CREATE_SUBPASS = 'auth/sub-password/create';
export const VER_SUBPASS = 'auth/sub-password/verify';

export const GENERATE_PDF_INVOICE = 'invoice/exportpdf';
// Document Download
export const DOCUMENT_DOWNLOAD = 'document/download';
export const DOCUMENT_FETCH = 'document/fetch';
export const DOCUMENT_CREATE = 'document/create';
export const DOCUMENT_UPDATE = 'document/update';
export const DOCUMENT_DELETE = 'document/delete';

// Currency
export const CURRENCY_RATE = 'wallet/rate';

// Admin
export const FETCH_RESETPASS_LOG = 'admin/fetchlog';
export const FIND_USER_SUBPASS = 'admin/find-user';
export const RESET_SUBPASS = 'admin/reset';
export const FETCH_RESET_SUBPASS_LOG = 'admin/logs';
export const FETCH_UPDATE_COMMISSION_LOG = 'admin/commission-logs';
export const USER_SEAMLESS_PROBLEM_ADD = 'admin/user-seamless/add';
export const USER_SEAMLESS_PROBLEM_FETCH = 'admin/user-seamless/fetch';
export const USER_SEAMLESS_PROBLEM_REMOVE = 'admin/user-seamless/remove';
export const USER_SEAMLESS_PROBLEM_SEARCH = 'admin/user-seamless/search';

// Point
export const FETCH_POINT = 'point/report';
export const FETCH_POINT_LOG = 'point/report/log';

// Coin
export const FETCH_COIN = 'point/report/coin';
export const FETCH_COIN_LOG = 'point/report/coin/log';

// Activity
export const FETCH_LOG_ACTIVITY = 'admin/activity-log';
export const FETCH_LOG_AGENT = 'user/active';

// Marketing
export const MARKETING_FETCH = 'marketing/fetch';
export const UPDATE_FEATURE = 'marketing/setfeature';

// Marketing for mascot
export const UPDATE_FEATURE_MASCOT = 'mascot/update/agent/feature';
export const UPDATE_AGENT_MASCOT = 'mascot/update/agent';

// Marketing for angpow
export const UPDATE_FEATURE_ANGPOW = 'angpow/update';

export const AMBSLOT_SECRET = 'b34f63f8733328b5c6c9a98354f70137';

// Support
export const SUPPORT_GET_USER = 'support/get/user';
export const SUPPORT_EDIT_USER = 'support/edit/user';
export const SUPPORT_GET_BET = 'support/get/bettransaction';

// Setting
export const SETTING_GET = 'setting/get';
export const SETTING_UPDATE = 'setting/update';

// Lobby Setting
export const LOBBY_SETTING_GET = 'config/fetch';
export const LOBBY_SETTING_SET = 'config/set';
export const LOBBY_SETTING_UPDATE = 'config/edit';

// White label
export const SETTING_IMAGE = 'setting/image';
export const EDIT_IMAGE = 'setting/image/update';
export const EDIT_THEME = 'setting/theme/update';
export const UPLOAD_IMAGE = 'setting/image/upload';
export const THEME_SELECTION = 'setting/lobby/theme';
export const UPDATE_THEME = 'setting/lobby/theme/update';
export const GET_WHITE_LABEL = 'whitelabel';

// RTP GAME
export const GET_GAMES_RTP_LIST = 'rtp/list';
export const UPDATE_RTP = 'rtp/update';

// MECHANIC
export const GET_PATTERN_LIST = 'pattern/list';
export const SET_PATTERN_MAINTENANCE = 'pattern/maintenance';
export const GET_MECHANIC_GAME_REPORT = 'report/mechanic/game';

// RTP AGENT
export const UPDATE_AGENT_RTP = 'rtp/agent/update';

// RISK MANAGEMENT
export const GET_RISK_MANAGEMENT_LIST = 'risk-management/config/fetch/games';
export const UPDATE_CONFIGS_RISK = 'risk-management/config/game';

// USER ONLINE
export const GET_USER_ONLINE = 'agent/online-users';

// public key
export const PUBLIC_KEY_HEADER = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCahEdNORcl0l9ZgIw6vspj8/LtRemJEAdJ0FqxHiC+Sf1TxUFSPj4SnxgG1kQWF5PFCezqt2V0824VcEdeeER6SSgPMKy02KsOzRtaWfteV6gbgBKyeFOu1CEYtGiULj+8sebKYvAme2qNjacl/6638bm25tgu9yAVQ6r4yZr1IwIDAQAB-----END PUBLIC KEY-----';

// Domain pool
export const DOMAIN_POOL_LIST = 'domain-pool/list';
export const DOMAIN_POOL_ADD = 'domain-pool/add';
export const DOMAIN_POOL_UPDATE = 'domain-pool/update';
